// WhatsApp.js

import React, { useState } from 'react';
import {Send} from "lucide-react"
import "./WhatsApp.css";

export default function WhatsApp() {
  const [chatHistory, setChatHistory] = useState([
    { text: 'Hi there!', time: '10:00 AM', date: "20/2/2024", isMe: false },
    { text: 'Hello! How can I help you?', time: '10:01 AM', date: "20/2/2024", isMe: true }
  ]);
  const [messageToSend, setMessageToSend] = useState('');

  const formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const sendMessage = () => {
    if (messageToSend.trim() !== '') {
      const now = new Date();
      const date = `${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()}`;
      const time = now.toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");

      // Update chat history with current message
      setChatHistory(prevChatHistory => [
        ...prevChatHistory,
        { text: messageToSend, time: time, date: date, isMe: true }
      ]);

      // Clear the message input
      setMessageToSend('');

      // Simulate a delayed response after 1.5 seconds
      setTimeout(() => {
        const response = getRandomResponse();
        const responseDate = `${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()}`;
        const responseTime = now.toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");

        // Update chat history again with the response
        setChatHistory(prevChatHistory => [
          ...prevChatHistory,
          { text: response, time: responseTime, date: responseDate, isMe: false }
        ]);
      }, 1500);
    }
  };

  const getRandomResponse = () => {
    const responses = [
      'Why did the web developer leave the restaurant? Because of the table layout.',
      'How do you comfort a JavaScript bug? You console it.',
      'An SQL query enters a bar, approaches two tables and asks: "May I join you?"',
      'What is the most used language in programming? Profanity.',
      'What is the object-oriented way to become wealthy? Inheritance.',
      'An SEO expert walks into a bar, bars, pub, tavern, public house, Irish pub, drinks, beer, alcohol'
    ];
    return responses[Math.floor(Math.random() * responses.length)];
  };

  return (
    <div className="whatsapp-container" >
      <div className="chat1 ">
        <div className="chat-history1 " >
          <ul className="list-unstyled">
            {chatHistory.map((message, index) => (
              <li key={index} className={`clearfix ${message.isMe ? 'me1' : 'other-message1'}`}>
                <div className={`mb-2 row d-flex justify-content-${message.isMe ? 'end' : 'start'}`}>
                <span className='message-data-time1 responsive-text-size fw-4'>{message.isMe ? 'Trigya' : 'Numberdar Solar'}</span>
                  <div className={`px-3  pt-3 position-relative col-lg-5 col-md-5 col-sm-10 message1 ${message.isMe ? 'me1 me-2' : 'other-message1 ms-2'}`}>
                    <span  style={{ left: message.isMe ? 10 : '', right: !message.isMe ? 10 : '', top: 2 }} className="position-absolute message-data-name1 text-end responsive-text-size">
                      <span className="message-data-time " style={{fontSize:'12px'}}>
                        {message.date === formatDate(new Date()) ? "Today" : message.date}
                      </span>
                      <span className=" ps-3 message-data-time " style={{fontSize:'12px'}}>
                        {message.time}
                      </span>
                    </span>
                    <div className={` position-relative `}>
                      <div>
                        <span className=" message-data-time responsive-text-size">{message.text}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="chat-message1 w-100" >
          <textarea
            name="message-to-send"
            id="message-to-send"
            placeholder="Type your message"
            rows="3"
            className="form-control"
            value={messageToSend}
            onChange={(e) => setMessageToSend(e.target.value)}
          ></textarea>
          <button className="send-button1" onClick={sendMessage}>
            <Send />
          </button>
        </div>
      </div>
    </div>
  );
}
